
















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import Order from "@/models/order/Order";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import MonthlyOverview from "@/components/planning/MonthlyOverview.vue";
import AsiToolbar from "@/components/common/AsiToolbar.vue";
import {Icon} from "@/helpers/icons";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiFadeTransition from "@/components/common/AsiFadeTransition.vue";

@Component({
	components: {AsiFadeTransition, AsiBtn, AsiToolbar, MonthlyOverview, AsiContentContainer}
})
export default class OrderTabPlanningEntries extends Vue {

	@Prop({type: Object, required: true})
	public order!: Order;

	private icons = Icon;
	private date: Date = new Date();
	private loading: boolean = false;

	private get title(): string {
		return this.$d(this.date, 'monthYearLong')
	}

	public mounted(): void {
		this.date.setDate(1);
	}

	private today(): void {
		this.date = new Date();
	}

	private prevMonth(): void {
		const date = new Date(this.date);
		date.setMonth(date.getMonth() - 1);
		this.date = date;
	}

	private nextMonth(): void {
		const date = new Date(this.date);
		date.setMonth(date.getMonth() + 1);
		this.date = date;
	}

	private loadingChanged(loading: boolean): void {
		this.loading = loading;
	}

}
